const ContractType = {
  MONOPOLY: [1, 'Độc quyền'],
  AUTHOR_RIGHT: [2, 'Tác quyền'],
};

export default ContractType;
